import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-173fe8dc")

_pushScopeId("data-v-173fe8dc")
const _hoisted_1 = {
  key: 0,
  class: "error"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "error__text" }, "Something Went Wrong", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_plusSVG = _resolveComponent("plusSVG")!

  return (_ctx.error)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_plusSVG, { class: "error__x" }),
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
})